<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Menubar from 'primevue/menubar'
import Button from 'primevue/button'
import Avatar from 'primevue/avatar'

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

const isAdmin = computed(() => auth.user?.role === 'admin')

const items = computed(() => {
  const list = [
    {
      label: 'Проверка',
      icon: 'pi pi-search',
      command: () => router.push({ name: 'check' }),
    },
    {
      label: 'Журнал',
      icon: 'pi pi-history',
      command: () => router.push({ name: 'check.log' }),
    },
    {
      label: 'Перечни',
      icon: 'pi pi-list',
      command: () => router.push({ name: 'scrolls' }),
    },
    {
      label: 'Загрузить',
      icon: 'pi pi-upload',
      command: () => router.push({ name: 'scrolls.upload' }),
    },
    {
      label: 'API-токены',
      icon: 'pi pi-key',
      command: () => router.push({ name: 'tokens' }),
    },
  ]
  if (isAdmin.value) {
    list.push({
      label: 'Пользователи',
      icon: 'pi pi-users',
      command: () => router.push({ name: 'users' }),
    })
  }
  return list
})

const pageTitle = computed(() => route.meta?.title ?? '')

async function handleLogout() {
  await auth.logout()
  router.push({ name: 'login' })
}

function goProfile() {
  router.push({ name: 'profile' })
}
</script>

<template>
  <div class="shell">
    <header class="shell__header">
      <div class="shell__brand" @click="router.push({ name: 'check' })">
        <i class="pi pi-shield" />
        <span>Росфинмониторинг</span>
      </div>

      <Menubar :model="items" class="shell__menu" />

      <div class="shell__user">
        <Button
          text
          severity="secondary"
          :label="auth.displayName"
          icon="pi pi-user"
          @click="goProfile"
        />
        <Button
          text
          severity="secondary"
          icon="pi pi-sign-out"
          aria-label="Выйти"
          @click="handleLogout"
        />
      </div>
    </header>

    <div class="shell__title" v-if="pageTitle">
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>

    <main class="shell__main">
      <RouterView />
    </main>
  </div>
</template>

<style scoped>
.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.shell__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  background: var(--p-surface-0, #fff);
  border-bottom: 1px solid var(--p-surface-200, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
}

.shell__brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0 0.5rem;
  color: var(--p-primary-color, #3b82f6);
}

.shell__brand i {
  font-size: 1.25rem;
}

.shell__menu {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0;
}

.shell__user {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.shell__title {
  padding: 1.25rem 1.5rem 0;
}

.shell__main {
  flex: 1;
  padding: 0;
}

:deep(.p-menubar) {
  background: transparent;
  border: none;
  padding: 0;
}
</style>
